/* GOTCHA: The SSN is currently the only mask implemented */
const masks = {
	SSN: [/\d/, /\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/],
};

export default masks;
